import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { JaversauditservicesService } from './javers-audit-services/javersauditservices.service';

@Component({
    selector: 'app-javersaudit',
    templateUrl: './javersaudit.component.html',
    styleUrls: ['./javersaudit.component.scss'],
    standalone: false
})
export class JaversauditComponent implements OnInit {

  rowbindingdata;
  
  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  getdata: any = []

  columnDefs;

  defaultColDef;

  rowSelection;

  
  backgroundColorScreen="";

  buttonColor="";

  components;
  value;


  constructor(private service:JaversauditservicesService,private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,private localStorageSettings: LocalStorageSettingsService,private constants: constants) { }

  ngOnInit() {
    this.columnDefs = [
      { headerName: 'Author', headerTooltip: 'Author', tooltipValueGetter: (params) => 'Author : ' + params.value, field: 'author', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Current State', headerTooltip: 'Current State', tooltipValueGetter: (params) => 'Current State : ' + params.value, field: 'state', filter: 'agTextColumnFilter', width: 250 },
	{ headerName: 'Previous State', headerTooltip: 'Previous State', tooltipValueGetter: (params) => 'Previous State : ' + params.value, field: 'previousModify', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Type', headerTooltip: 'Type', tooltipValueGetter: (params) => 'Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Commit Date', headerTooltip: 'Commit Date', tooltipValueGetter: (params) => 'Commit Date : ' + params.value, field: 'commitDate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Commit Date Instant', headerTooltip: 'Commit Date Instant', tooltipValueGetter: (params) => 'Commit Date Instant : ' + params.value, field: 'commitDateInstant', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Version', headerTooltip: 'Version', tooltipValueGetter: (params) => 'Version : ' + params.value, field: 'version', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Changed Properties', headerTooltip: 'Changed Properties', tooltipValueGetter: (params) => 'Changed Properties : ' + params.value, field: 'changedProperties', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Managed Type', headerTooltip: 'Managed Type', tooltipValueGetter: (params) => 'Managed Type : ' + params.value, field: 'managedType', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Snapshot Id', headerTooltip: 'Snapshot Id', tooltipValueGetter: (params) => 'Snapshot Id : ' + params.value, field: 'snapshotpk', filter: 'agTextColumnFilter', width: 250 },
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }
   //excel export function
    onBtExport() {
      this.rowbindingdata.api.exportDataAsCsv();
    }
  
    //pagination code
    onPaginationChanged() {
      if (this.rowbindingdata.api) {
        this.lastpage = this.rowbindingdata.api.paginationIsLastPageFound();
        this.currentpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1
        this.nextpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1
        this.nextpageplusone = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1 + 1
        this.totalpages = this.rowbindingdata.api.paginationGetTotalPages()
      }
    }
    //this function is for going to the given page number 
    onSearchChange(searchValue: number) {
  
      this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
    }
  
    // below function is for changing the no of rows per page
    onPageSizeChanged(newPageSize) {
      var value = this.pagesize
      this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
    }
  
    // below function is for going to next page
    onBtNext() {
      console.log("next")
      this.rowbindingdata.api.paginationGoToNextPage();
    }
  
    // below function for going to previous page
    onBtPrevious() {
      console.log("previous")
      this.rowbindingdata.api.paginationGoToPreviousPage();
    }
  
    // below function for going to first page
    onBtFirst() {
      console.log("first")
      this.rowbindingdata.api.paginationGoToFirstPage();
    }
  
    // below function for going to last page
    onBtLast() {
      console.log("last")
      this.rowbindingdata.api.paginationGoToLastPage();
    }
    //pagination code ends

  onGridReady(params){
    this.rowbindingdata = params;
    this.service.retrievejaversaudit().subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }


}
